export default __webpack_public_path__ + "static/media/smedetoften-property-05.3782e2a3.jpg";